import React, { FC } from 'react';
import { graphql } from 'gatsby';

import ProductVariant from 'components/ProductVariant/ProductVariant';

import { IPropsProductVariants } from './models';
import './ProductVariants.scss';
import './ShadowProductVariants.scss';

const ProductVariants: FC<IPropsProductVariants> = ({ productVariants }) => {
  const {
    properties: { heading, productVariant },
  } = productVariants[0];

  return (
    <div data-test="ProductVariants" className="product-variants__wrapper">
      {heading ? <p className="product-variants__title">{heading.toString()}</p> : null}
      {productVariant
        ? productVariant.map((elements, index) => (
            <ProductVariant
              productVariant={[elements]}
              key={`product-variant-${index.toString()}`}
            />
          ))
        : null}
    </div>
  );
};

export const query = graphql`
  fragment FragmentProductVariants on TProductVariants {
    properties {
      heading
      productVariant {
        properties {
          link {
            name
            url
            target
            queryString
          }
          title
        }
      }
    }
  }
`;

export default ProductVariants;
